import { action, computed, makeObservable, observable } from 'mobx';
import { parseQuery } from '../helpers/parseQuery';
import { GameModes } from '../constants/gameModes';
import { DefaultQueryParams } from '../constants/defaultQueryParams';
import {gameMainDrawer} from "../game/drawers/gameMainDrawer";

export class ApplicationStore {
  accessToken = '';

  isSoundsLoaded = false;

  isAuthenticated = false;

  isConnectionLost = false;

  isSocketConnected = false;

  isJackpotSocketConnected = false;

  isAuthDataReceived = false;

  isShowJackpot = true;

  isJackPotOpacity = false;

  hasJackPot = false;

  isMaintenance = false;

  tournamentIconsInfo = [];

  constructor() {
    makeObservable(this, {
      isDemo: computed,
      accessToken: observable,
      isShowJackpot: observable,
      hasJackPot: observable,
      isMaintenance: observable,
      isSoundsLoaded: observable,
      isConnectionLost: observable,
      isAuthenticated: observable,
      isSocketConnected: observable,
      isJackpotSocketConnected: observable,
      isAuthDataReceived: observable,
      isJackPotOpacity: observable,
      tournamentIconsInfo: observable.deep,
      setIsDemo: action.bound,
      setIsJackPotOpacity: action.bound,
      setAccessToken: action.bound,
      setIsSoundsLoaded: action.bound,
      setHasJackPot: action.bound,
      setIsMaintenance: action.bound,
      setIsShowJackpot: action.bound,
      setIsAuthenticated: action.bound,
      setIsSocketConnected: action.bound,
      setIsAuthDataReceived: action.bound,
      setIsJackpotSocketConnected: action.bound,
      setTournamentIconsInfo: action.bound,
    });
  }

  setIsJackpotSocketConnected(bool) {
    this.isJackpotSocketConnected = bool;
  }

  setTournamentIconsInfo(data) {
    this.tournamentIconsInfo = data;
  }

  setIsMaintenance(bool) {
    this.isMaintenance = bool;
  }

  setIsJackPotOpacity(bool) {
    this.isJackPotOpacity = bool;
  }

  setHasJackPot(bool) {
    this.hasJackPot = bool;
  }

  setIsShowJackpot(bool) {
    this.isShowJackpot = bool;
    gameMainDrawer.gameJackpot.GameJackpotContainer.visible = bool;
  }

  setIsDemo(boolValue) {
    this.isDemo = boolValue;
  }

  setIsSoundsLoaded(bool) {
    this.isSoundsLoaded = bool;
  }

  setIsConnectionLost(bool) {
    this.isConnectionLost = bool;
  }

  setIsSocketConnected(bool) {
    this.isSocketConnected = bool;
  }

  setAccessToken(accessToken) {
    this.accessToken = accessToken;
  }

  setIsAuthenticated(isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
  }

  setIsAuthDataReceived(isAuthDataReceived) {
    this.isAuthDataReceived = isAuthDataReceived;
  }

  get isDemo() {
    const { [DefaultQueryParams.Mode]: mode } = parseQuery(window.location.search);
    return mode === GameModes.Fun;
  }
}

export const applicationStore = new ApplicationStore();
